<template>
    <div :class="$style.mobile_tab">
        <p :class="$style.mobile_tab__description">
            {{ locales("lc_mobile_description") }}
        </p>
        <div :class="$style.mobile_tab__qr">
            <img :class="$style.mobile_tab__qr_image" :src="qrImageSrc" alt="QR Code" />
        </div>
        <div :class="$style.mobile_tab__stores">
            <a
                :class="$style.mobile_tab__store_link"
                href="https://apps.apple.com/us/app/ganttpro/id1579665713"
                target="_blank"
                rel="noopener noreferrer"
            >
                <img :class="$style.mobile_tab__store_icon" :src="appStoreIconSrc" alt="App Store" />
                <!-- <span :class="$style.mobile_tab__store_text">App Store</span> -->
            </a>
            <a
                :class="$style.mobile_tab__store_link"
                href="https://play.google.com/store/apps/details?id=com.ganttpro.app"
                target="_blank"
                rel="noopener noreferrer"
            >
                <img :class="$style.mobile_tab__store_icon" :src="googlePlayIconSrc" alt="Google Play" />
                <!-- <span :class="$style.mobile_tab__store_text">Google Play</span> -->
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: "LearningCenterMobileTab",
    components: {},
    props: {
        searchQuery: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            locales: __,
        };
    },
    computed: {
        qrImageSrc() {
            return `${GT.cdn}/imgs/learnCenter/apps-qr.png`;
        },
        appStoreIconSrc() {
            return `${GT.cdn}/imgs/learnCenter/app-apple.png`;
        },
        googlePlayIconSrc() {
            return `${GT.cdn}/imgs/learnCenter/app-google.png`;
        },
    },
};
</script>

<style module lang="less">
@import "../../../../../../less/_variables.less";
@import "../../../../../../less/_mixins.less";

.mobile_tab {
    display: flex;
    flex-direction: column;
    gap: 32px;
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    width: 436px;
    height: 100%;
}

.mobile_tab__header {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.mobile_tab__title {
    font-family: Lato-Bold, sans-serif;
    font-size: 20px;
    line-height: 28px;
    color: #191919;
    margin: 0;
    padding: 0;
}

.mobile_tab__description {
    font-family: Lato-Regular, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    color: #191919;
    font-feature-settings:
        "liga" off,
        "clig" off;
    margin: 0;
    padding: 0;
}

.mobile_tab__qr {
    display: flex;
    justify-content: center;
    margin-top: 44px;
}

.mobile_tab__qr_image {
    width: 160px;
    height: 160px;
    display: block;
}

.mobile_tab__stores {
    display: flex;
    flex-direction: row;
    gap: 20px;
    align-items: center;
    justify-content: center;
}

// .mobile_tab__store_link {
//   align-items: center;
// }

.mobile_tab__store_icon {
    width: 113px;
    height: 32px;
    display: block;
    flex-shrink: 0;
    object-fit: contain;
}

.mobile_tab__store_text {
    font-family: Lato-Regular, sans-serif;
    font-size: 14px;
    line-height: 20px;
    color: #191919;
}
</style>
